import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { StoreProvider } from "./context/StoreContext";
import { ToastContainer } from "react-toastify";
import { UserProvider } from "./context/userContext";
import "react-toastify/dist/ReactToastify.css";

const rootElement = document.getElementById("root");
const app = (
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <StoreProvider>
        <UserProvider>
          <App />
          <ToastContainer />
        </UserProvider>
      </StoreProvider>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}

reportWebVitals();
